

















































import { Component, Vue, Prop } from "vue-property-decorator"
import { mapState } from "vuex"

@Component({
  computed: {
    ...mapState("ServiceOrder", {
      newBulkServiceOrder: "newBulkServiceOrder",
    }),
  },
})
export default class ServiceOrderCreateReviewTable extends Vue {
  @Prop({ default: true }) readonly selectedBusiness!: Model
  newBulkServiceOrder!: ServiceOrderState["newBulkServiceOrder"]
}
